import { lazy } from "react";

const LazyReorderTrip = lazy(() => import("./ReorderTrip"));
export default LazyReorderTrip;
